import React from "react";
import { Card, Row, Col, Badge } from "react-bootstrap";
import { cpkBadgeVariant, fmtNum } from "../../Services/processo/dashboardProcessoUtils";
import EstatisticasFrequenciaDashboard from "./EstatisticasFrequenciaDashboard";
import PlanoBadgeSelector from "./PlanoBadgeSelector";

const PlanoDashboardCard = ({
    selectedPlanoId,
    setSelectedPlanoId,
    planoOptions,
    estatisticasPlano,
    estatisticasFrequencia
   
}) => {
    return (
        <Card>
            <Card.Body>
                <Row className="g-3 align-items-end">
                    <Col md={4} sm={12}>
                        <div>
                            <label className="form-label text-muted small fw-bold">
                                Plano de Controle
                            </label>
                            <PlanoBadgeSelector
                                selectedPlanoId={selectedPlanoId}
                                setSelectedPlanoId={setSelectedPlanoId}
                                planoOptions={planoOptions}
                            />
                        </div>
                    </Col>

                    <Col md={8} sm={12}>
                        <Row className="g-3 align-items-center">
                            <Col md={4} sm={6}>
                                <div className="text-muted small">Cpk (médio do plano)</div>
                                <h5 className="mb-1">
                                    <Badge bg={cpkBadgeVariant(estatisticasPlano?.cpkMedio)}>
                                        {fmtNum(estatisticasPlano?.cpkMedio, 3)}
                                    </Badge>
                                </h5>
                                <div className="small text-muted">
                                    Controles: {estatisticasPlano?.totalControles ?? 0}
                                </div>
                            </Col>
                            <Col md={4} sm={6}>
                                <div className="text-muted small">Desvios & Alertas</div>
                                <h5 className="mb-1 d-flex gap-2 align-items-center">
                                    <Badge bg={(estatisticasPlano?.totalRegistrosForaGlobal ?? 0) > 0 ? "danger" : "success"} title="Total de registros fora de especificação">
                                        {estatisticasPlano?.totalRegistrosForaGlobal ?? 0} Reg.
                                    </Badge>
                                    {(estatisticasPlano?.itensAlertaEstatistica ?? 0) > 0 && (
                                        <Badge bg="warning" text="dark" style={{fontSize: '0.6em'}} title="Controles com alertas estatísticos">
                                            {estatisticasPlano?.itensAlertaEstatistica} Ctrs.
                                        </Badge>
                                    )}
                                </h5>
                                <div className="small text-muted">
                                    {fmtNum(estatisticasPlano?.totalRegistrosForaPct ?? 0, 2)}% fora
                                </div>
                            </Col>
                            <Col md={4} sm={12}>
                                <EstatisticasFrequenciaDashboard 
                                    estatisticas={estatisticasFrequencia}
                                />
                            </Col>
                        </Row>
                    </Col>
                </Row>

            </Card.Body>
        </Card>
    );
};

export default PlanoDashboardCard